import { Button, Input, message, Space, Table, Modal, Tag, Dropdown, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import Server from "../../../server/Server";
import URL from "../../../server/URL";
import { ExclamationCircleFilled, DownOutlined } from '@ant-design/icons';
import moment from "moment";
import EUtils, { IButtonConfig } from "../../../utils/EUtils";
import ESearch, { IMoreConfig, ISearchConfig } from "../../../components/esearch/ESearch";
import EAttribute from "../../../utils/EAttribute";
import ComparisonProductEdit from "../../03.masterdata/comparisonproduct/ComparisonProductEdit";
const { confirm } = Modal;

const ComparisonOnlineProduct = () => {
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState<any>({ pageIndex: 1, pageSize: 50 });
    const [dataSource, setDataSource] = useState<any>([]);
    const [editRecord, setEditRecord] = useState<any>({});
    const [scrollY, setScrollY] = useState("");
    const refComparisonProductEdit = useRef<any>(null);
    const columns: any[] = [
        {
            key: 'comparisonProductName', title: '产品名称', dataIndex: 'comparisonProductName'
            , fixed: 'left', ellipsis: true, width: 120,
            render: (text: any, record: any) => <a onClick={() => {
                setEditRecord({
                    viewMode: 1,
                    comparisonProductID: record.comparisonProductID,
                    comparisonProductName: record.comparisonProductName
                });
                refComparisonProductEdit.current.setVisible(true);
            }}>{text}</a>
        },
        { key: 'companyName', title: '保险公司', dataIndex: 'companyName', width: 120, ellipsis: true },
        { key: 'insuranceType', title: '保险险种', dataIndex: 'insuranceType', width: 100, ellipsis: true },
        {
            key: 'insureArea', title: '禁保区域', dataIndex: 'insureArea', width: 120, ellipsis: {
                showTitle: true, // 鼠标悬浮展示内容
            },
            render: (text: any, record: any) => {
                return text?.length > 10 ? text.slice(0, 10) + '...' : text;
            }
        },
        {
            key: 'insureRequirements', title: '询价要求', dataIndex: 'insureRequirements', width: 120, ellipsis: {
                showTitle: true, // 鼠标悬浮展示内容
            },
            render: (text: any, record: any) => {
                return text?.length > 10 ? text.slice(0, 10) + '...' : text;
            }
        },
        {
            key: 'productFeatures', title: '产品特色', dataIndex: 'productFeatures', width: 200, ellipsis: {
                showTitle: true, // 鼠标悬浮展示内容
            },
            render: (text: any, record: any) => {
                return text?.length > 10 ? text.slice(0, 10) + '...' : text;
            }
        },
        {
            key: 'clauses', title: '保险条款', dataIndex: 'clauses', width: 120, ellipsis: {
                showTitle: true, // 鼠标悬浮展示内容
            },
            render: (text: any, record: any) => {
                return text?.length > 10 ? text.slice(0, 10) + '...' : text;
            }
        },
        {
            key: 'insureTimeDesc', title: '询价时效', dataIndex: 'insureTimeDesc', width: 120, ellipsis: {
                showTitle: true, // 鼠标悬浮展示内容
            },
            render: (text: any, record: any) => {
                return text?.length > 10 ? text.slice(0, 10) + '...' : text;
            }
        },
        {
            title: '临牌超牌', dataIndex: 'isTemp', width: 80,
            render: (text: any) => {
                return text ? <Tag color="green">是</Tag> : <Tag color="red">否</Tag>
            }
        },
        {
            title: '启用状态', dataIndex: 'isActive', width: 80,
            render: (text: any) => {
                return text ? <Tag color="green">启用</Tag> : <Tag color="red">禁用</Tag>
            }
        },
        {
            title: '上线状态', dataIndex: 'isOnline', width: 80,
            render: (text: any) => {
                return text ? <Tag color="green">上线</Tag> : <Tag color="red">下线</Tag>
            }
        },
        {
            key: 'remark', title: '备注', dataIndex: 'remark', width: 150, ellipsis: {
                showTitle: true, // 鼠标悬浮展示内容
            },
            render: (text: any, record: any) => {
                return text?.length > 15 ? text.slice(0, 15) + '...' : text;
            }
        },
        {
            title: '操作', width: 60, ellipsis: true, align: 'center', fixed: 'right',
            render(value: any, record: any, index: any) {
                var configs: IButtonConfig[] = [
                    { name: '上线', onClick: () => { showOnlineConfirm(record); }, hidden: record.isOnline },
                    { name: '下线', onClick: () => { showOnlineConfirm(record); }, hidden: !record.isOnline, danger: true },
                ];
                return EUtils.InitButtons(configs);
            }
        }];

    const [mergeColumns, setMergeColumns] = useState<any>(columns);
    const resize = () => setScrollY(EUtils.getTableScroll(82, ''));
    //页面加载完成后才能获取到对应的元素及其位置
    useEffect(() => {
        resize();
    }, [dataSource])

    const showOnlineConfirm = (record: any) => {
        confirm({
            title: record.isOnline ? '下线申报产品' : '上线申报产品',
            icon: <ExclamationCircleFilled />,
            content: '申报产品[' + record.comparisonProductName + ']，确认要'
                + (record.isOnline ? '下线' : '上线'),
            okText: '确定',
            cancelText: '取消',
            onOk() {
                var param = {
                    comparisonProductID: record.comparisonProductID,
                    isOnline: !record.isOnline
                }
                Server.Post(URL.OnlineComparisonProduct.SetOnlineComparisonProduct, param).then((response: any) => {
                    if (response.isSuccess) {
                        message.success((record.isOnline ? '下线' : '上线') + '成功!');
                        loadData();
                    } else {
                        message.warn(response.returnMsg);
                    }
                })
            },
            onCancel() {
            },
        });
    };

    useEffect(() => {
        initColumns();
        loadData();
    }, [])

    useEffect(() => {
        loadData();
    }, [page]);
    const initColumns = () => {
        var request = {
            typeEnum: 0
        }
        Server.Post(URL.AttributeRule.GetAttributeRuleDetailByType, request, false).then((response: any) => {
            if (response.isSuccess) {
                var newColumns = EAttribute.initColumns(columns, columns.length - 2, response.data);
                setMergeColumns([...newColumns]);
            }
        });
    }

    const loadData = () => {
        var params = {
            ...page,
            options: refESearch.current?.getOptions()
        };
        Server.Post(URL.OnlineComparisonProduct.GetOnlineComparisonProductList, params).then((response: any) => {
            if (response.isSuccess) {
                setDataSource(response.data);
            }
        });
    }
    const refESearch = useRef<any>(null);

    const searchConfig: ISearchConfig[] = [
        { filedID: 'ComparisonProductName', filedName: '产品名称' },
        { filedID: 'CompanyName', filedName: '保险公司' },
        { filedID: 'InsuranceType', filedName: '保险险种' },
        { filedID: 'InsureRequirements', filedName: '询价要求' },
        { filedID: 'ProductFeatures', filedName: '产品特色' },
        { filedID: 'Remark', filedName: '备注' },
    ];
    const moreConfig: IMoreConfig[] = [
        { type: 'select', filedID: 'CompanyID', title: '保险公司', dataUrl: URL.Company.GetCompanyOptions },
        {
            type: 'select', filedID: 'InsuranceType', title: '保险险种', data: [
                { value: '货运险', label: '货运险' },
                { value: '物流责任险', label: '物流责任险' },
                { value: '雇主责任险', label: '雇主责任险' },
                { value: '团体意外险', label: '团体意外险' },
                { value: '仓储险', label: '仓储险' }]
        },
        { type: 'select', filedID: 'IsOnline', title: '上线状态', data: [{ value: true, label: '上线' }, { value: false, label: '下线' }] },
    ];

    return <div>
        <ESearch searchConfig={searchConfig} moreConfig={moreConfig} onLoad={loadData} resize={resize} ref={refESearch} />
        <div>
            <div style={{ backgroundColor: '#fafafa', border: '1px solid #e7e7eb', borderBottom: 'none', height: '45px', padding: '5px' }}>
                <span style={{ lineHeight: '30px', margin: '5px', fontWeight: 'bold' }}></span>
                <Space style={{ float: 'right' }}>
                </Space>
            </div>
            <Table size="small" bordered
                scroll={dataSource?.length > 0 ? { x: 'max-content', y: scrollY } : { x: 'max-content' }}
                columns={mergeColumns} dataSource={dataSource} pagination={{
                    position: ['bottomRight'],
                    style: { margin: '5px' },
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: total,
                    showTotal: ((total) => {
                        return "共" + total + "条";
                    }),
                    current: page.pageIndex,
                    defaultCurrent: 20,
                    pageSize: page.pageSize,
                    pageSizeOptions: [10, 20, 50, 100, 200],
                    onShowSizeChange: ((page, pageSize) => {
                        setPage({
                            pageIndex: page,
                            pageSize: pageSize
                        });
                    }),
                    onChange: ((page, pageSize) => {
                        setPage({
                            pageIndex: page,
                            pageSize: pageSize
                        });
                    })
                }}
                summary={(pageData) => {
                    return <Table.Summary fixed>
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={1} >
                                <Typography.Text>合计:{dataSource?.length}</Typography.Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} colSpan={8} align={'center'}>
                                <Typography.Text></Typography.Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2} colSpan={mergeColumns.length - columns.length}>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={3} colSpan={1}></Table.Summary.Cell>
                            <Table.Summary.Cell index={4} colSpan={1} align={'center'}></Table.Summary.Cell>
                        </Table.Summary.Row>
                    </Table.Summary>
                }} />
        </div>
        <ComparisonProductEdit reLoad={loadData} {...editRecord} ref={refComparisonProductEdit} />
    </div >
}
export default ComparisonOnlineProduct;